<script setup>

import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import CustomToggle from "@/components/global-themed/inputs/CustomToggle.vue";
import {computed, onMounted, ref, watch} from "vue";
import RangeDatepicker from "@/components/global-themed/inputs/RangeDatepicker.vue";
import moment from "moment";
import {useStore} from "vuex";

const comparePickerEl = ref(null);

const store = useStore();

const compare = computed(() => store.getters['traffic/compare']);

const range = computed(() => store.getters['traffic/range']);

const compareRange = computed(() => store.getters['traffic/compareRange']);

const localFilter = ref({
  compare: false,
  range: [],
  compareRange: [],
});

onMounted(() => {
  localFilter.value = {
    compare: compare.value,
    range: range.value,
    compareRange: compareRange.value,
  };
})

const localCompare = computed(() => localFilter.value.compare);
const localCompareRange = computed(() => localFilter.value.compareRange);
const localRange = computed(() => localFilter.value.range);

const localRangeTo = computed(() => localRange.value[1] ? moment(localRange.value[1]) : undefined);
const localCompareFrom = computed(() => localCompareRange.value[0] ? moment(localCompareRange.value[0]) : undefined);
const localCompareTo = computed(() => localCompareRange.value[1] ? moment(localCompareRange.value[1]) : undefined);

watch(localCompare, () => {
  if (!localFilter.value.compare) {
    localFilter.value.compareRange = [
      undefined,
      undefined,
    ];
    return;
  }

  if (localFilter.value.compareRange[0] || localFilter.value.compareRange[1]) return;

  localFilter.value.compareRange = [
    moment(range.value[0]).subtract(1, 'month').format(),
    moment(range.value[1]).subtract(1, 'month').format(),
  ];
}, {
  immediate: true,
})

watch(localRangeTo, function () {
  if (!localRangeTo.value || !localCompareTo.value) return;

  const diff = localCompareTo.value.diff(localCompareFrom.value, 'days');
  let changed = false;

  // Handle when the current range is re-selected to be after the compare range
  if (localRangeTo.value.isBefore(localCompareTo.value)) {
    localFilter.value.compareRange[1] = localRangeTo.value.clone();
    changed = true;
  }

  if (localRangeTo.value.isBefore(localCompareFrom.value)) {
    localFilter.value.compareRange[0] = localRangeTo.value.clone().subtract(diff, 'days');
    changed = true;
  }

  if (changed) {
    comparePickerEl.value.toggleShowPicker();
  }
});


const handleSubmit = () => {
  store.dispatch('traffic/setFilter', localFilter.value);
}

</script>

<template>
  <div
    class="tw-bg-white tw-rounded tw-p-8 tw-flex tw-gap-6 tw-items-end"
  >
    <div>
      <RangeDatepicker
        :range="localFilter.range"
        :compare-range="localFilter.compareRange"
        @change="(newRange) => localFilter.range = newRange"
      />
    </div>
    <div class="tw-pb-3">
      <CustomToggle
        v-model="localFilter.compare"
        size="large"
      >
        <template #label>
          Compare with
        </template>
      </CustomToggle>
    </div>
    <div v-if="localFilter.compare">
      <RangeDatepicker
        ref="comparePickerEl"
        :range="localFilter.compareRange"
        :compare-range="localFilter.range"
        variant="secondary"
        @change="(newRange) => localFilter.compareRange = newRange"
      />
    </div>
    <div>
      <DefaultButton @click="handleSubmit">
        Apply Filter
      </DefaultButton>
    </div>
  </div>
</template>
